var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup8(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 217,
    height: 207,
    viewBox: "0 0 217 207",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 10",
    d: "M71 90.9726L216 53V207H71V90.9726Z",
    fill: "#333232"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 11",
    d: "M0 45.4536L140.121 16.9161L215.328 53.3892L71.4258 91.6936L0 45.4536Z",
    fill: "#2B2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 12",
    d: "M0 45.4536L71.2158 91.2357V206H0V45.4536Z",
    fill: "#4D4B4B"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup8);
export default __webpack_public_path__ + "static/media/Group 8.b8997de9cc0c6ebc5dec642d4f5723ca.svg";
export { ForwardRef as ReactComponent };